import React from 'react'
import './Loading.scss'

const Loading = () => {
  return (
    <div className='b-container-loading'>
        <div className='b-logo'>
          <img src="/assets/logo1.png" alt='Logotipo de Meettalent'></img>
        </div>
    </div>
  )
}

export default Loading